import { render, staticRenderFns } from "./addbulk.vue?vue&type=template&id=14800a4a&"
import script from "./addbulk.vue?vue&type=script&lang=js&"
export * from "./addbulk.vue?vue&type=script&lang=js&"
import style0 from "./addbulk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports